import { render, staticRenderFns } from "./HeaderTaskManagement.vue?vue&type=template&id=7c0840bc&scoped=true"
import script from "./HeaderTaskManagement.vue?vue&type=script&lang=js"
export * from "./HeaderTaskManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0840bc",
  null
  
)

export default component.exports